<template>
  <div class="wrapper-full blink">
    <el-container>
      <el-main :style="`height:${dispH - 400}px;`" class="border-normal">
        <VideoPlayer
          v-if="!isHugeMapVisible"
          :record="record"
          :BlinkVideo="BlinkVideo"
          :currentEye="currentEye"
          :zoom="1"
          :src="videoSrc"
          :realTotalTime="-1"
          @if-OS="ifOS"
          @show-capture="showCapture"
        />
      </el-main>
      <el-aside width="500px" :style="`height:${dispH - 400}px;padding-bottom:5px`">
        <div class="aside-container">
          <div style="width: 500px; height: 380px; padding-top: 5px; text-align: center">
            <canvas id="proportionCanvas" width="300" height="300" @click="gotoQuality"></canvas>
          </div>
          <!-- <div style="width: 500px; height: 380px; padding-top: 5px"> -->
          <!-- <el-tabs type="border-card" v-model="blinkName" style="font-size:24px;"> -->
          <!-- <el-tab-pane :label="$t('langcfg.txtBlinkQuality')" name="proportion"><canvas id="proportionCanvas" width="300" height="300" @click="gotoQuality"></canvas></el-tab-pane> -->

          <!-- <el-tab-pane :label="$t('langcfg.txtBlinkProportion')" name="proportion"><canvas id="proportionCanvas" width="300" height="300" @click="gotoQuality"></canvas></el-tab-pane> -->
          <!-- <el-tab-pane :label="$t('langcfg.txtBlinkQuality')" name="quality"><canvas id="qualityCanvas" width="300" height="300" @click="blinkingArea"></canvas></el-tab-pane> -->
          <!-- </el-tabs> -->
          <!-- </div> -->
          <el-card class="blink-data">
            <p class="blink-p">
              <span class="p-left" :style="leftWidth">{{ $t("langcfg.txtBlinkResponse") }}</span
              ><span class="p-center">:</span
              ><span class="p-right" :style="rightWidth">{{ TotalBlk }}</span>
            </p>
            <p class="blink-p">
              <span class="p-left" :style="leftWidth">{{ $t("langcfg.txtBlinkInterval") }}</span
              ><span class="p-center">:</span
              ><span class="p-right" :style="rightWidth">{{ IBI }}s</span>
            </p>
            <p class="blink-p">
              <span class="p-left" :style="leftWidth">{{
                $t("langcfg.txtCompleteBlinkTimes")
              }}</span
              ><span class="p-center">:</span
              ><span class="p-right" :style="rightWidth">{{ CmpltBlk }}</span>
            </p>
            <!-- <p class="blink-p">
              <span class="p-left" :style="leftWidth">{{
                $t("langcfg.txtIncompleteBlinkTimes")
              }}</span
              ><span class="p-center">:</span
              ><span class="p-right" :style="rightWidth">{{ NocmpltBlk }}</span>
            </p> -->
            <p class="blink-p">
              <span class="p-left" :style="leftWidth">{{
                $t("langcfg.txtIncompleteBlinkRate")
              }}</span
              ><span class="p-center">:</span
              ><span class="p-right" :style="rightWidth">{{ NocmpltBlk }}/{{ TotalBlk }}</span>
            </p>
            <!-- <p>{{ $t('langcfg.txtBlinkInterval') }}: {{ IBI }}S</p>
            <p>{{ $t('langcfg.txtCompleteBlinkTimes') }}: {{ CmpltBlk }}</p>
            <p>{{ $t('langcfg.txtIncompleteBlinkTimes') }}: {{ NocmpltBlk }}</p>
            <p>{{ $t('langcfg.txtIncompleteBlinkRate') }}: {{ NocmpltBlk }}/{{ TotalBlk }}</p> -->
          </el-card>
        </div>
      </el-aside>
    </el-container>
    <blink-chart
      :dispW="1800"
      :dispH="420"
      :resblhArray="resblhArray"
      :language="language"
      :currentEye="currentEye"
      :record="record"
      :realTotalTime="videoTime"
    ></blink-chart>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import VideoPlayer from "./basic/VideoPlayer";
import { objectCopy, getImageUrl, isDefined } from "../../shared/utils";
import BlinkDraw from "../../dryeye/js/blinkdraw.js";
import BlinkChart from "./BlinkChart.vue";
import EVENTS from "../../bus";
import fileSys from "../../fileoprators/fileSystem";
export default {
  name: "Blink",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      videoSrc: "",
      isHugeMapVisible: false,
      mapVisible: false,
      mycurrentrecord: {},
      photos: [],
      BlinkVideo: true,
      valChart: [],
      TotalBlk: 0, // 总眨眼次数
      NocmpltBlk: 0, // 不完全眨眼次数
      CmpltBlk: 0, // 完全眨眼次数
      IBI: 0, // 总眨眼间隔
      PBR: 0 / 0, // 不完全眨眼比例
      CmpltBlkInv: 0, // 完全眨眼间隔, OPI的分母
      // blhArray: [], // 眨眼程度序列
      // timeArray: [], // 时间序列，和blhArray一一对应
      resblhArray: [], // 0.02s 眨眼程度序列
      blinkName: "proportion",
      videoTime: 0,
      isLanguage: ""
    };
  },
  props: {
    language: {
      type: String,
      default: ""
    },
    record: {
      type: Object
    },
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  watch: {
    currentEye(newType) {
      this.currentEye = newType;
      this.isHugeMapVisible = false;
      this.mapVisible = false;
      this.ifOS(this.record);
      this.initDraw();
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.ifOS(newRecord);
        }
      },
      immediate: true,
      deep: true
    },
    language: function () {
      this.initDraw();
      if (this.videoTime) {
        this.$bus.$emit("video-time", this.videoTime);
      }
    }
  },
  async created() {
    this.videoTime = await this.getDuration();

    if (this.videoTime) {
      this.$bus.$emit("video-time", this.videoTime);
    }
    this.isLanguage = window.settings.language;
  },
  mounted() {
    this.ifOS(this.record);
    // 模拟数据
    this.initDraw();
  },
  updated() {
    this.isLanguage = window.settings.language;
  },
  components: {
    VideoPlayer,
    BlinkChart
  },
  methods: {
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    async ifOS(record, value = 0) {
      // ifOS (record, value = 0) {
      this.mycurrentrecord = objectCopy(record);
      console.log(
        "blink ifOS",
        this.mycurrentrecord,
        this.mycurrentrecord.content[`data${this.currentEye}`]
      );
      if (this.mycurrentrecord.content[`data${this.currentEye}`].blink) {
        const { blink } = this.mycurrentrecord.content[`data${this.currentEye}`];
        const { photos } = blink;
        this.photos = photos;
        const { filename } = this.photos[0];
        this.videoSrc = this.getImageURL(filename);

        const {
          NumNocmpltBlk,
          NumCmpltBlk,
          NumTotalBlk,
          BlkInv,
          RatioNocmpltBlk,
          CmpltBlkInv,
          resblhArray
        } = blink;
        this.resblhArray = resblhArray;
        this.NocmpltBlk = isDefined(NumNocmpltBlk) ? Number(NumNocmpltBlk.toFixed()) : 0;
        this.CmpltBlk = isDefined(NumCmpltBlk) ? Number(NumCmpltBlk.toFixed()) : 0;
        this.TotalBlk = isDefined(NumTotalBlk) ? Number(NumTotalBlk.toFixed()) : 0;
        // this.IBI = isDefined(BlkInv) ? Number(BlkInv.toFixed(1)) : 0
        // this.CmpltBlkInv = isDefined(CmpltBlkInv) ? Number(CmpltBlkInv.toFixed(1)) : 0
        // this.PBR = isDefined(RatioNocmpltBlk) ? Number(RatioNocmpltBlk.toFixed()) : 0

        // 调试用
        let videoTime = await this.getDuration();
        if (!this.mycurrentrecord.content[`data${this.currentEye}`].blink.videoTime) {
          this.mycurrentrecord.content[`data${this.currentEye}`].blink.videoTime = videoTime;
          this.$bus.$emit(EVENTS.updateData, this.mycurrentrecord, {}, {}, () => {});
        }
        this.videoTime = this.mycurrentrecord.content[`data${this.currentEye}`].blink.videoTime
          ? this.mycurrentrecord.content[`data${this.currentEye}`].blink.videoTime
          : videoTime;
        if (this.videoTime) {
          this.$bus.$emit("video-time", this.videoTime);
        }
        this.IBI = this.TotalBlk
          ? Number(this.videoTime / this.TotalBlk ? this.videoTime / this.TotalBlk : 0).toFixed(1)
          : 0;
        this.PBR = isDefined(RatioNocmpltBlk) ? Number(RatioNocmpltBlk.toFixed()) : 0;
        this.CmpltBlkInv = this.CmpltBlk
          ? Number(this.videoTime / this.CmpltBlk ? (this.videoTime / this.CmpltBlk).toFixed(1) : 0)
          : 0;

        // this.blhArray = blhArray
        // this.timeArray = timeArray
      }
    },
    // 拼接src
    getImageURL(filename) {
      return getImageUrl(filename, window.server, window.token);
    },
    showCapture() {
      this.$emit("show-capture", "blink");
    },
    initDraw(state) {
      let proportion = 100 - (this.NocmpltBlk / this.TotalBlk).toFixed(2) * 100;
      let lang = this.$i18n.messages[this.$i18n.locale].langcfg;
      let drawproportion = new BlinkDraw(
        lang,
        "#proportionCanvas",
        proportion ? proportion : 0,
        "proportion",
        this.TotalBlk,
        this.$i18n.locale
      );
      // let quality = 97
      // let drawquality = new BlinkDraw(lang, '#qualityCanvas', quality, 'quality', 95, this.$i18n.locale, 100)
    },
    getYAngle(cx, cy, x2, y2) {
      let x = Math.abs(cx - x2);
      let y = Math.abs(cy - y2);
      let z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
      let tan = x / y;
      let radina = Math.atan(tan); //用反三角函数求弧度
      let angle = Math.floor(180 / (Math.PI / radina)) || 0; //将弧度转换成角度
      if (x2 > cx && y2 > cy) {
        // point在第四象限
        angle = -1 * angle;
      }
      if (x2 == cx && y2 > cy) {
        // point在y轴负方向上
        angle = 0;
      }
      if (x2 < cx && y2 > cy) {
        //point在第三象限
        angle = angle;
      }
      if (x2 < cx && y2 == cy) {
        //point在x轴负方向
        angle = 90;
      }
      if (x2 < cx && y2 < cy) {
        // point在第二象限
        angle = 180 - angle;
      }
      if (x2 == cx && y2 < cy) {
        //point在y轴正方向上
        angle = 180;
      }
      if (x2 > cx && y2 < cy) {
        //point在第一象限
        angle = 180 + angle;
      }
      if (x2 > cx && y2 == cy) {
        //point在x轴正方向上
        angle = -90;
      }
      return angle;
    },
    blinkingArea(evt) {
      let x = evt.clientX;
      let y = evt.clientY;
      let canvas = document.querySelector("#qualityCanvas");
      let rect = canvas.getBoundingClientRect();
      x -= rect.left;
      y -= rect.top;
      // (x, y) 就是鼠标在 canvas 单击时的坐标
      let angle = this.getYAngle(150, 150, x, y);
      let lang = this.$i18n.messages[this.$i18n.locale].langcfg;
      if (angle >= 90 && angle < 108) {
        let quality = 97;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          95,
          this.$i18n.locale,
          100
        );
      } else if (angle >= 108 && angle < 126) {
        let quality = 92;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          90,
          this.$i18n.locale,
          94
        );
      } else if (angle >= 126 && angle < 144) {
        let quality = 87;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          85,
          this.$i18n.locale,
          89
        );
      } else if (angle >= 144 && angle < 162) {
        let quality = 82;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          80,
          this.$i18n.locale,
          84
        );
      } else if (angle >= 162 && angle < 180) {
        let quality = 77;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          75,
          this.$i18n.locale,
          79
        );
      } else if (angle >= 180 && angle < 198) {
        let quality = 72;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          70,
          this.$i18n.locale,
          74
        );
      } else if (angle >= 198 && angle < 216) {
        let quality = 67;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          65,
          this.$i18n.locale,
          69
        );
      } else if (angle >= 216 && angle < 234) {
        let quality = 62;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          60,
          this.$i18n.locale,
          64
        );
      } else if (angle >= 234 && angle < 252) {
        let quality = 57;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          55,
          this.$i18n.locale,
          59
        );
      } else if (angle >= 252 && angle < 270) {
        let quality = 52;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          50,
          this.$i18n.locale,
          54
        );
      } else if (angle >= -90 && angle < -72) {
        let quality = 47;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          45,
          this.$i18n.locale,
          49
        );
      } else if (angle >= -72 && angle < -54) {
        let quality = 42;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          40,
          this.$i18n.locale,
          44
        );
      } else if (angle >= -54 && angle < -36) {
        let quality = 37;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          35,
          this.$i18n.locale,
          39
        );
      } else if (angle >= -36 && angle < -18) {
        let quality = 32;
        let drawquality = new BlinkDraw(
          lang,
          "#qualityCanvas",
          quality,
          "quality",
          30,
          this.$i18n.locale,
          34
        );
      }
    },
    gotoQuality() {
      // this.blinkName = 'quality'
    },
    // 获取当前视频时间，调试用
    async getDuration() {
      const video = document.createElement("video");
      video.src = this.videoSrc;
      await new Promise((resolve) => {
        video.onloadedmetadata = () => resolve();
      });

      let videotime = video.duration > 60 ? 60 : video.duration;

      return Math.floor(videotime);
    }
  },
  computed: {
    leftWidth() {
      switch (this.isLanguage) {
        case "zh_CN":
          return "width: 50%";
          break;
        case "en_US":
          return "width: 55%";
          break;
        case "ja":
          return "width: 60%";
          break;
        case "de":
          return "width: 78%";
          break;
        case "it":
          return "width: 88%";
          break;
        default:
          break;
      }
    },
    rightWidth() {
      switch (this.isLanguage) {
        case "zh_CN":
          return "width: 46%";
          break;
        case "en_US":
          return "width: 41%";
          break;
        case "ja":
          return "width: 36%";
          break;
        case "de":
          return "width: 18%";
          break;
        case "it":
          return "width: 10%";
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.border-normal {
  border: none;
}
.footer {
  width: 100%;
  height: 80px;
}
.wrapper-full {
  height: 98%;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.blink {
  position: relative;
}
.baseFontSize {
  font-size: 30px;
  float: right;
  line-height: 50px;
}
.switch-video {
  text-align: right;
}
.blink-data {
  width: 500px;
  height: 100%;
  text-align: left;
  font-size: 25px;
  border: none;
  border-top: #3c3f48 1px solid;
  background: #2d3039;
  color: #bcbfc8;
  padding-top: 32px;
}
.blink-p span {
  display: block;
}
.p-left {
  width: 50%;
  text-align: right;
  float: left;
  line-height: 41px;
}
.p-center {
  float: left;
  line-height: 41px;
}
.p-right {
  width: 46%;
  text-align: left;
  float: right;
  line-height: 41px;
}
.blink-data /deep/ .el-card__body > p {
  margin: 20px 0px;
  height: 29px;
}
/deep/ .el-form-item {
  line-height: 50px;
  height: 50px;
}
/deep/.el-form-item__label {
  margin-left: 5px;
  font-size: 30px;
  line-height: 50px;
}
/deep/.el-form-item__content {
  line-height: 65px;
  height: 65px;
  font-size: 30px;
}
/deep/ .el-radio-group {
  padding-left: 10px;
}
/deep/ .el-radio__label {
  font-size: 30px;
  vertical-align: middle;
  margin-right: 10px;
}
/deep/ .el-radio__inner {
  width: 20px;
  height: 20px;
}
/deep/ .el-tabs__nav-scroll {
  background: #2d3039;
}
/deep/ .el-tabs--border-card {
  border: none;
}
/deep/ .el-tabs__nav {
  background: #232428;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2d3039;
  border: 1px solid #fff;
  margin-left: 1px;
  margin-top: 1px;
}
/deep/ .el-tabs__content {
  text-align: center;
  background: #2d3039;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
  color: #909399;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: none;
  font-size: 26px;
}
// /deep/ .el-card__body {
//   margin-top: 165px;
// }
</style>



// WEBPACK FOOTER //
// src/dryeye/components/Blink.vue